// Add this new component to your project - ThemeMenu.jsx
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const ThemeMenu = ({ isOpen, onClose, theme, setTheme, updateUser, THEMES }) => {
  // Handle click outside to close menu
  useEffect(() => {
    if (!isOpen) return;
    
    const handleOutsideClick = (e) => {
      if (!e.target.closest('.theme-menu-content')) {
        onClose();
      }
    };
    
    // Add event listener with capture phase to ensure it runs first
    document.addEventListener('mousedown', handleOutsideClick, true);
    
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick, true);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Create portal to render outside of normal DOM hierarchy
  return ReactDOM.createPortal(
    <>
      {/* Overlay to capture clicks */}
      <div 
        className="fixed inset-0 bg-transparent z-[9998]" 
        onClick={onClose}
      ></div>
      
      {/* Menu content */}
      <div 
        className="theme-menu-content fixed right-4 top-20 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg z-[9999]"
      >
        <div className="p-2">
          <h3 className="text-sm font-medium mb-2 px-2 text-gray-900 dark:text-white">Select Theme</h3>
          <div className="space-y-1">
            {Object.entries(THEMES)
              .filter(([key]) => key !== 'CHAOS')
              .map(([key, value]) => (
                <button
                  key={key}
                  onClick={async () => {
                    // Set theme in context
                    setTheme(value);
                    onClose();
                    
                    try {
                      // Save preference to backend
                      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users/me/theme`, {
                        method: 'PUT',
                        headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${localStorage.getItem('token')}`
                        },
                        body: JSON.stringify({
                          themePreference: value
                        })
                      });
                      
                      if (!response.ok) {
                        throw new Error('Failed to save theme preference');
                      }
                      
                      const data = await response.json();
                      
                      // Update user in context with new theme preference
                      updateUser({
                        themePreference: data.themePreference
                      });
                    } catch (error) {
                      console.error('Theme update error:', error);
                    }
                  }}
                  className={`flex items-center w-full px-3 py-2 text-sm rounded-md text-gray-900 dark:text-white
                    ${theme === value ? 'bg-gray-200 dark:bg-gray-700' : 'hover:bg-gray-100 dark:hover:bg-gray-700'}`}
                >
                  <div 
                    className="w-4 h-4 rounded-full mr-2"
                    style={{
                      backgroundColor: 
                        value === THEMES.DARK ? '#121212' : 
                        value === THEMES.LIGHT ? '#fff' : 
                        value === THEMES.BLUE ? '#e3f2fd' : 
                        value === THEMES.GREEN ? '#e8f5e9' : 
                        value === THEMES.PURPLE ? '#f3e5f5' : '#121212',
                      border: value === THEMES.LIGHT ? '1px solid #ddd' : 'none'
                    }}
                  ></div>
                  {key.charAt(0) + key.slice(1).toLowerCase()}
                </button>
              ))}
          </div>
        </div>
      </div>
    </>,
    document.body // Attach to body instead of component tree
  );
};

export default ThemeMenu;